import m = require("mithril")
import {simpleContent, elementId, classList} from './helpers'
import {LabelItem} from '../../model/items/labelItem'
import {inputTextItemView} from "./inputText";
import {Vnode} from "mithril";

export class LabelView  {
	public static component = {
        view: (vnode :Vnode) => {
            return m(LabelView, vnode.attrs);
        }
	};
	private cellItem: LabelItem;

	constructor(attr: any) {
		this.cellItem = <LabelItem>attr.attrs.cellItem;
	}

	view() : any {
		var assignedControl = this.cellItem.form.grid.cellById[this.cellItem.labelFor]; // grid is set before this statement


		return m('label.label.text-label', {
				'class' : classList({
					'control-checked' : assignedControl && assignedControl.active
				}),
				'for': elementId(this.cellItem, this.cellItem.labelFor)
			},
			simpleContent(this.cellItem, this.cellItem.childrenTags),

			this.cellItem.cell.hasInputText() ? inputTextItemView(this.cellItem.cell.getInputText()!) : '' // this.cellItem.cell.getInputText() is checked
		);

	}
}